export enum RelativeEventRuleRelationship {
    Specific = "Specific",
    Every = "Every",
    FirstOfDay = "FirstOfDay",
    LastOfDay = "LastOfDay"
}